import { Box, CssBaseline, Toolbar } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import LandingAppBar from "./LandingAppBar";
import { useState } from "react";
import LandingDrawer from "./LandingDrawer";
import { ScrollTotop } from "modules/common";
import { Helmet } from "react-helmet";
import { useGetBlogPostsWebQuery } from "api/blogApi";
import DocumentDrawer from "./DocumentDrawer";

export default function LandingLayout() {

    const [open, setOpen] = useState(false)
    const toggleDrawer = () => {
        setOpen((prev) => !prev)
    }

    const { data: blogPosts } = useGetBlogPostsWebQuery({ limit: 100 })

    const location = useLocation()
    const showDocumentDrawer = location.pathname.includes("documentation")

    return (
        <>
            <Helmet>
                <meta name="keywords" content="softpos, pos, mpos, payment, Soft POS KSA, Point of Sale Software Saudi Arabia, Mobile POS Solutions KSA, POS Systems for Small Businesses in Saudi Arabia, Saudi Arabia POS Software, Retail POS Systems KSA, Cloud-Based POS Solutions KSA, POS Integration Saudi Arabia, Saudi Arabia Payment Processing, POS Solutions for Retail KSA, Contactless Payment Solutions Saudi Arabia, POS Hardware and Software KSA, E-commerce Payment Solutions KSA, Digital Payment Systems Saudi Arabia, POS for Grocery Stores KSA, POS Software Providers KSA,softpos، pos، mpos، الدفع، Soft POS KSA، برامج نقاط البيع في المملكة العربية السعودية، حلول نقاط البيع المتنقلة في المملكة العربية السعودية، أنظمة نقاط البيع للشركات الصغيرة في المملكة العربية السعودية، برامج نقاط البيع في المملكة العربية السعودية، أنظمة نقاط البيع بالتجزئة في المملكة العربية السعودية، حلول نقاط البيع المستندة إلى السحابة في المملكة العربية السعودية ، تكامل نقاط البيع بالمملكة العربية السعودية، المملكة العربية السعودية معالجة الدفع، حلول نقاط البيع للبيع بالتجزئة بالمملكة العربية السعودية، حلول الدفع بدون تلامس بالمملكة العربية السعودية، أجهزة وبرامج نقاط البيع بالمملكة العربية السعودية، حلول دفع التجارة الإلكترونية بالمملكة العربية السعودية، أنظمة الدفع الرقمية بالمملكة العربية السعودية، نقاط البيع لمتاجر البقالة بالمملكة العربية السعودية، برامج نقاط البيع بالمملكة العربية السعودية مقدمو الخدمات المملكة العربية السعودية" />
                <meta name="description" content="EzPay is an app that helps you receive payments in a simple way. It allows you to use your phone to collect payments from customers, either by scanning a barcode or sending a link to the customer." />
            </Helmet>
            <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                <CssBaseline />
                <ScrollTotop />
                <LandingAppBar toggleDrawer={toggleDrawer} blogPosts={blogPosts} />
                <LandingDrawer open={open} toggleDrawer={toggleDrawer} blogPosts={blogPosts} />
                {showDocumentDrawer && <DocumentDrawer />}
                <Toolbar />
                <Outlet />
            </Box>
        </>
    )
}